
    require(
      "!../../node_modules/gatsby/dist/loaders/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { 
     return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projects-c-2-acijwi-km-1-jlyok-ih-b-7-a-lg.json") })
        }
      }, "path---projects-c-2-acijwi-km-1-jlyok-ih-b-7-a-lg");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby/dist/loaders/gatsby-module-loader?name=path---projects-c-2-acijwi-km-1-jlyok-ih-b-7-a-lg!./.cache/json/projects-c-2-acijwi-km-1-jlyok-ih-b-7-a-lg.json
// module id = ./node_modules/gatsby/dist/loaders/gatsby-module-loader/index.js?name=path---projects-c-2-acijwi-km-1-jlyok-ih-b-7-a-lg!./.cache/json/projects-c-2-acijwi-km-1-jlyok-ih-b-7-a-lg.json
// module chunks = 15178676390636814000